"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[35439],{

/***/ 173698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getBackground = (props) => {
  const { variant, theme } = props;
  return variant && (theme.brand[variant] || theme.colors[variant]) || variant || theme.colors.dark;
};
const StyledTag = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  background-color: ${props.outline ? "#fff" : getBackground(props)};
  color: ${props.outline ? getBackground(props) : props.theme.colors.white};
  border: ${props.outline ? `1px solid ${getBackground(props)}` : ""} ;
  display: inline;
  padding: 2px 8px;
  border-radius: 2px;
  font-size: 10px;
  line-height: 12px;
  font-weight: 500;
  align-self: center;
  `);
const Tag = (_a) => {
  var _b = _a, {
    variant,
    outline = false,
    children,
    className
  } = _b, props = __objRest(_b, [
    "variant",
    "outline",
    "children",
    "className"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, __spreadValues({
    className,
    outline,
    variant
  }, props), children);
};




/***/ }),

/***/ 662295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WR": function() { return /* binding */ mapComboWithKey; },
/* harmony export */   "Xf": function() { return /* binding */ getSkusForProductsCombos; },
/* harmony export */   "aU": function() { return /* binding */ getTotalAmount; },
/* harmony export */   "bT": function() { return /* binding */ getNewComboData; },
/* harmony export */   "bb": function() { return /* binding */ getTotalDiscount; },
/* harmony export */   "g5": function() { return /* binding */ getComboPromotionDetail; },
/* harmony export */   "n7": function() { return /* binding */ calculateProductComboQuantity; },
/* harmony export */   "qE": function() { return /* binding */ getDiscountByCombo; },
/* harmony export */   "sE": function() { return /* binding */ countAndGetBenefitDescription; }
/* harmony export */ });
/* unused harmony export getTotalAmountBeforePromotion */
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(634655);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54230);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


// only used in Combo
// suggest move combo modules later
const getComboPromotionDetail = (promotion, latestPrice)=>{
    const items = [];
    const benefit = promotion.benefit;
    if (benefit.discount) {
        const { flat , percent , maxAmount  } = benefit.discount;
        let discount = 0;
        if (percent) {
            discount = latestPrice * percent / 100;
            if (discount > maxAmount) {
                discount = maxAmount;
            }
        }
        if (flat) {
            discount = flat;
        }
        items.push({
            icon: "cash",
            image: null,
            name: null,
            discount
        });
    }
    if (benefit.voucher) {
        items.push({
            icon: "voucher",
            image: null,
            name: benefit.voucher.name,
            discount: null
        });
    }
    benefit.gifts.forEach((el)=>{
        items.push({
            icon: "gift",
            image: el.imageUrl,
            name: el.name,
            discount: null
        });
    });
    if (items.length > 1) {
        return {
            hasImage: false,
            icon: "gift",
            tag: (0,_i18n__WEBPACK_IMPORTED_MODULE_0__.t)("Tặng ngay"),
            description: (0,_i18n__WEBPACK_IMPORTED_MODULE_0__.t)("{{ItemsLength}} phần qu\xe0", {
                ItemsLength: items.length
            })
        };
    }
    if (items.length === 1) {
        const item = items[0];
        var _name;
        return {
            hasImage: !!item.image,
            image: item.image || undefined,
            icon: item.image ? undefined : item.icon,
            tag: item.icon === "cash" ? (0,_i18n__WEBPACK_IMPORTED_MODULE_0__.t)("Giảm ngay") : (0,_i18n__WEBPACK_IMPORTED_MODULE_0__.t)("Tặng ngay"),
            discount: item.discount || undefined,
            title: item.discount ? undefined : (_name = item.name) !== null && _name !== void 0 ? _name : undefined
        };
    }
};
const getTotalAmountBeforePromotion = (combo, isApplyNewLogic)=>{
    var ref, ref1;
    const field = isApplyNewLogic || !((ref = combo.promotion.condition) === null || ref === void 0 ? void 0 : (ref1 = ref.exclusions) === null || ref1 === void 0 ? void 0 : ref1.length) ? "latestPrice" : "supplierRetailPrice";
    return combo.conditions.reduce((total, currentValue)=>{
        return total + (currentValue.product.price[field] || 0) * currentValue.requiredQuantity;
    }, 0);
};
const getTotalAmount = (combo, isApplyNewLogic)=>{
    return getTotalAmountBeforePromotion(combo, isApplyNewLogic) - getDiscountByCombo(combo, isApplyNewLogic);
};
const getDiscountByCombo = (combo, isApplyNewLogic)=>{
    var ref;
    const { flat , percent , maxAmount  } = ((ref = combo.promotion.benefit) === null || ref === void 0 ? void 0 : ref.discount) || {};
    if (flat) return flat;
    if (percent) {
        const totalAmount = getTotalAmountBeforePromotion(combo, isApplyNewLogic);
        if (typeof maxAmount === "number") return Math.min(percent * totalAmount / 100, maxAmount);
        return percent * totalAmount / 100;
    }
    return 0;
};
const getTotalDiscount = (combo, isApplyNewLogic)=>{
    var ref, ref1;
    let totalDiscount = getDiscountByCombo(combo, isApplyNewLogic);
    // Promotion is applied with other promotions (combo.promotion.condition?.exclusions.length = null)
    if (isApplyNewLogic || !isApplyNewLogic && !((ref = combo.promotion.condition) === null || ref === void 0 ? void 0 : (ref1 = ref.exclusions) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        const totalProductDiscount = combo.conditions.reduce((total, curr)=>{
            return total + (curr.product.price.supplierRetailPrice - curr.product.price.latestPrice) * curr.requiredQuantity;
        }, 0);
        totalDiscount += totalProductDiscount;
    }
    return totalDiscount;
};
const getNewComboData = (selectingProduct, comboGroup, activeCombo, isApplyNewLogic)=>{
    const { totalProductInCombo , comboKey , conditionKey , product  } = selectingProduct;
    const selectedGroup = comboGroup[totalProductInCombo];
    const selectedCombo = selectedGroup.combos.find((combo)=>combo.key === comboKey) || _objectSpread({}, activeCombo);
    const unaggregatedData = _objectSpreadProps(_objectSpread({}, selectedCombo), {
        conditions: selectedCombo.conditions.map((c)=>c.key === conditionKey ? _objectSpreadProps(_objectSpread({}, c), {
                product
            }) : c)
    });
    const newActiveCombo = _objectSpreadProps(_objectSpread({}, unaggregatedData), {
        discountByCombo: getDiscountByCombo(unaggregatedData, isApplyNewLogic),
        totalDiscount: getTotalDiscount(unaggregatedData, isApplyNewLogic),
        totalAmount: getTotalAmount(unaggregatedData, isApplyNewLogic)
    });
    const newGroup = _objectSpreadProps(_objectSpread({}, comboGroup), {
        [totalProductInCombo]: {
            combos: selectedGroup.combos.map((cb)=>cb.key === comboKey ? newActiveCombo : cb)
        }
    });
    return {
        newActiveCombo,
        newGroup
    };
};
const countAndGetBenefitDescription = (benefit, numberDisplayFormat)=>{
    let count = 0;
    let description = "";
    const benefits = [];
    const { discount , voucher , gifts  } = benefit;
    const discountValue = (discount === null || discount === void 0 ? void 0 : discount.flat) || (discount === null || discount === void 0 ? void 0 : discount.percent) || 0;
    if (discount && discountValue > 0) {
        count++;
        benefits.push("".concat((0,_i18n__WEBPACK_IMPORTED_MODULE_0__.t)("Giảm ngay"), " ").concat((discount === null || discount === void 0 ? void 0 : discount.flat) ? (0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(discountValue, numberDisplayFormat) : "".concat(discountValue, "%")));
    }
    if (voucher) {
        count++;
        benefits.push(voucher.quantity > 1 ? "".concat(voucher.quantity, " ").concat(voucher.name) : voucher.name);
    }
    if (gifts && !!gifts.length) {
        gifts.forEach((param)=>{
            let { name , quantity =0  } = param;
            count++;
            benefits.push(quantity > 1 ? "".concat(quantity, " ").concat(name) : name);
        });
    }
    benefits.forEach((benefit, index)=>{
        description += index === 0 ? benefit : index < benefits.length - 1 ? ", ".concat(benefit) : " ".concat((0,_i18n__WEBPACK_IMPORTED_MODULE_0__.t)("v\xe0"), " ").concat(benefit);
    });
    return {
        numberOfBenefit: count,
        benefitDescription: description
    };
};
const mapComboWithKey = (products)=>products.map((p)=>p.combos.map((cb, key)=>_objectSpreadProps(_objectSpread({}, cb), {
                key: key + 1,
                conditions: cb.conditions.map((c, i)=>_objectSpreadProps(_objectSpread({}, c), {
                        key: i + 1
                    }))
            })));
const calculateProductComboQuantity = (items)=>{
    return items.reduce((quantity, item)=>{
        return quantity + item.quantity;
    }, 0);
};
const getSkusForProductsCombos = (items)=>{
    const skus = [];
    items.forEach((param)=>{
        let { items  } = param;
        items.forEach((i)=>{
            if (!skus.includes(i.sku)) {
                skus.push(i.sku);
            }
        });
    });
    return skus;
};


/***/ }),

/***/ 453594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ useComboList; },
/* harmony export */   "eV": function() { return /* binding */ useComboTitle; },
/* harmony export */   "rK": function() { return /* binding */ useProductCombos; }
/* harmony export */ });
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(662295);
/* harmony import */ var hooks_useDetailPromotion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(170604);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(278585);
/* harmony import */ var _useDiscovery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88837);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







const useComboList = (sku)=>{
    const { result: { combos  } = {
        combos: []
    } , isLoading: isLoadingDynamicCombo ,  } = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_1__/* .useRecommendationCombosData */ .jG)(sku);
    const { result: { productSets  } = {
        productSets: []
    } , isLoading: isLoadingAutogenCombo ,  } = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_1__/* .useRecommendationProductsData */ .mF)(sku);
    const getCookedComboList = ()=>{
        const allCombos = [];
        for(let i = 0; i < combos.length; i++){
            const combo = combos[i];
            const mainProductIndex = combo.products.findIndex((el)=>el.product.productInfo.sku === sku);
            const mainProduct = combo.products[mainProductIndex];
            const restProducts = combo.products.filter((_el, index)=>index !== mainProductIndex);
            allCombos.push({
                type: "dynamic",
                items: [
                    mainProduct,
                    ...restProducts
                ].map((item)=>({
                        quantity: item.quantity,
                        product: item.product
                    })),
                promotionId: combo.id,
                promotion: combo.promotion,
                supplierRetailPrice: Number(combo.supplierRetailPrice),
                latestPrice: Number(combo.latestPrice)
            });
        }
        for(let i1 = 0; i1 < productSets.length; i1++){
            const productSet = productSets[i1];
            const supplierRetailPrice = productSet.products.reduce((acc, curr)=>{
                var ref, ref1;
                return acc + Number((curr === null || curr === void 0 ? void 0 : (ref = curr.prices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.supplierRetailPrice) || 0);
            }, 0);
            const latestPrice = productSet.products.reduce((acc, curr)=>{
                var ref, ref1;
                return acc + Number((curr === null || curr === void 0 ? void 0 : (ref = curr.prices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.latestPrice) || 0);
            }, 0);
            const mainProduct1 = productSet.products.find((el)=>el.productInfo.sku === sku);
            const restProducts1 = productSet.products.filter((el)=>el.productInfo.sku !== sku);
            mainProduct1 && allCombos.push({
                type: "autogen",
                items: [
                    mainProduct1,
                    ...restProducts1
                ].map((prod)=>({
                        quantity: 1,
                        product: prod
                    })),
                supplierRetailPrice,
                latestPrice
            });
        }
        return allCombos;
    };
    return {
        isLoading: isLoadingDynamicCombo || isLoadingAutogenCombo,
        comboList: getCookedComboList()
    };
};
const TITLE_MAP = {
    autogen: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Thường được mua c\xf9ng"),
    dynamic: (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Mua k\xe8m nhận ưu đ\xe3i")
};
const useComboTitle = (comboList)=>{
    // handle title 'Mua kèm nhận ưu đãi' || 'Thường được mua cùng'
    const { 0: title , 1: setTitle  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>{
        if (comboList.length === 0) return undefined;
        return TITLE_MAP[comboList[0].type];
    });
    const onSlideChange = (index)=>{
        setTitle(TITLE_MAP[comboList[index].type]);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (comboList.length > 0) setTitle(TITLE_MAP[comboList[0].type]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(comboList)
    ]);
    return {
        title,
        onSlideChange
    };
};
const useProductCombos = (param)=>{
    let { screen =types__WEBPACK_IMPORTED_MODULE_3__/* .ProductComboScreen.product_detail */ ._.product_detail , skus , selectingSku  } = param;
    const { applyNewLogicToCalculateComboPrice =false  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    const { result , isLoading: isLoadingCombos  } = (0,hooks_useDetailPromotion__WEBPACK_IMPORTED_MODULE_5__/* .useGetProductsCombos */ .T)(skus);
    // Add key for each combo & condition in combo (to serve calculating/updating on FE)
    const productCombos = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const selectedProductCombo = result.products.filter((pd)=>pd.sku === selectingSku);
        return !isLoadingCombos && result.products.length > 0 ? screen === types__WEBPACK_IMPORTED_MODULE_3__/* .ProductComboScreen.product_detail */ ._.product_detail ? (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .mapComboWithKey */ .WR)(result.products)[0] : selectedProductCombo.length > 0 ? (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .mapComboWithKey */ .WR)(selectedProductCombo)[0] : [] : [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        result,
        isLoadingCombos,
        selectingSku
    ]);
    // Group of combos that have the same number of products
    const { 0: comboGroup , 1: setComboGroup  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const { 0: activeCombo , 1: setActiveCombo  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const selectComboProduct = (selectingProduct, setSelectingCombo)=>{
        if (comboGroup && activeCombo) {
            const { newActiveCombo , newGroup  } = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .getNewComboData */ .bT)(selectingProduct, comboGroup, activeCombo, applyNewLogicToCalculateComboPrice);
            if (!setSelectingCombo) {
                setActiveCombo(newActiveCombo);
                setComboGroup(newGroup);
            } else {
                setSelectingCombo(newActiveCombo);
            }
        } else {
            throw Error("Invalid comboGroup or activeCombo");
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (productCombos.length) {
            // Group combos with the same number of products
            const groupObj = productCombos.reduce((result, cb)=>{
                var ref;
                const combos = ((ref = result[cb.totalProduct]) === null || ref === void 0 ? void 0 : ref.combos) || [];
                const comboTemp = _objectSpreadProps(_objectSpread({}, cb), {
                    // in the first render -> select the first product in each condition to show
                    conditions: cb.conditions.map((_param)=>{
                        var { products  } = _param, restCondition = _objectWithoutProperties(_param, [
                            "products"
                        ]);
                        return _objectSpreadProps(_objectSpread({}, restCondition), {
                            product: products[0]
                        });
                    })
                });
                combos.push(_objectSpreadProps(_objectSpread({}, comboTemp), {
                    discountByCombo: (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .getDiscountByCombo */ .qE)(comboTemp, applyNewLogicToCalculateComboPrice),
                    totalDiscount: (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .getTotalDiscount */ .bb)(comboTemp, applyNewLogicToCalculateComboPrice),
                    totalAmount: (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .getTotalAmount */ .aU)(comboTemp, applyNewLogicToCalculateComboPrice)
                }));
                return _objectSpreadProps(_objectSpread({}, result), {
                    [cb.totalProduct]: {
                        combos
                    }
                });
            }, {});
            setComboGroup(groupObj);
            if (!activeCombo) {
                // Default set the first combo in the first group is active
                const firstGroup = Object.values(groupObj)[0];
                setActiveCombo(firstGroup.combos[0]);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(productCombos)
    ]);
    return {
        productCombosData: result.products,
        comboGroup,
        setComboGroup,
        productCombos,
        activeCombo,
        setActiveCombo,
        isLoadingCombos,
        selectComboProduct
    };
};


/***/ }),

/***/ 170604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ useDetailPromotion; },
  "T": function() { return /* binding */ useGetProductsCombos; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-976cccc57b/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(859676);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(723357);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./services/clients/api.ts
var api = __webpack_require__(44844);
// EXTERNAL MODULE: ../../packages/auth/dist/interceptor.es.js
var interceptor_es = __webpack_require__(847143);
;// CONCATENATED MODULE: ./services/ppm.ts


api/* ppmApi.addInterceptor */.Gp.addInterceptor(interceptor_es/* accessTokenInterceptor */.E);
class PpmService {
    async getRelatedPromotion(param) {
        let { type , sku , terminalId , terminal , language  } = param;
        var ref, ref1;
        const res = await api/* ppmApi.get */.Gp.get("/promotions", {
            params: {
                type,
                skus: sku,
                terminalId,
                terminal
            },
            headers: {
                "Accept-Language": language || "*"
            }
        });
        return (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1.promotions) || [];
    }
    async getPrivatePromotion(param) {
        let { type , sku , terminalId , terminal , language  } = param;
        var ref, ref1;
        const res = await api/* ppmApi.get */.Gp.get("/private-promotions", {
            params: {
                type,
                skus: sku,
                terminalId,
                terminal
            },
            headers: {
                "Accept-Language": language || "*"
            }
        });
        return (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1.promotions) || [];
    }
    async getProductsCombos(param) {
        let { skus , terminalId , language  } = param;
        const res = await api/* ppmApi.post */.Gp.post("/products/combos", {
            skus,
            terminalId
        }, {
            headers: {
                "Accept-Language": language || "*"
            }
        });
        return res.data;
    }
}
const ppmService = new PpmService();

// EXTERNAL MODULE: ./types/promotions.ts
var promotions = __webpack_require__(857387);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var index_es = __webpack_require__(420577);
;// CONCATENATED MODULE: ./hooks/useDetailPromotion.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








const transformPromotionV2 = (promotion, productSku)=>{
    const { condition  } = promotion;
    const basePromotion = _objectSpreadProps(_objectSpread({}, promotion), {
        condition: _objectSpreadProps(_objectSpread({}, condition), {
            hasProductCondition: !!condition.skus.filter((param)=>{
                let { sku  } = param;
                return sku === productSku;
            }).length
        })
    });
    return [
        basePromotion
    ];
};
// Flat benefit
const transformPromotion = (promotion, productSku)=>{
    const { benefit , condition  } = promotion;
    const { gifts , voucher , discount  } = benefit;
    const basePromotion = _objectSpreadProps(_objectSpread({}, promotion), {
        condition: _objectSpreadProps(_objectSpread({}, condition), {
            hasProductCondition: !!condition.skus.filter((param)=>{
                let { sku  } = param;
                return sku === productSku;
            }).length
        })
    });
    const giftData = gifts && gifts.length ? [
        _objectSpreadProps(_objectSpread({}, basePromotion), {
            benefit: {
                type: promotions/* BENEFIT_TYPE.gifts */.s.gifts,
                data: gifts
            }
        }), 
    ] : [];
    const voucherData = voucher && Object.keys(voucher).length ? [
        _objectSpreadProps(_objectSpread({}, basePromotion), {
            benefit: {
                type: promotions/* BENEFIT_TYPE.voucher */.s.voucher,
                data: voucher
            }
        }), 
    ] : [];
    const discountData = discount && Object.keys(discount).length ? [
        _objectSpreadProps(_objectSpread({}, basePromotion), {
            benefit: {
                type: promotions/* BENEFIT_TYPE.discount */.s.discount,
                data: discount
            }
        }), 
    ] : [];
    return [
        ...discountData,
        ...giftData,
        ...voucherData
    ];
};
/** Valid promotions:
 * public
 * applied for product sku or all skus
 * applied for sellerId of product or all sellers
 * not expired
 */ const filterValidPromotions = (promotions, param)=>{
    let { seller , sku: productSku  } = param;
    return promotions.filter((param)=>{
        let { applySellerIds , startedAt , endedAt , condition  } = param;
        const isValidSku = !condition.skus.length || condition.skus.filter((param)=>{
            let { sku  } = param;
            return sku === productSku;
        }).length;
        const isValidSellerId = !applySellerIds.length || seller && applySellerIds.includes(seller.id);
        const isValidDate = !!startedAt && !!endedAt && (0,helpers/* checkExpiryDate */.N6)(new Date(startedAt).toISOString(), new Date(endedAt).toISOString());
        return isValidSku && isValidSellerId && isValidDate;
    });
};
const getShowedPromotions = (promotions, price)=>{
    return promotions.filter((param)=>{
        let { condition  } = param;
        if (!condition) return false;
        const { hasProductCondition , orderValueMin  } = condition;
        return hasProductCondition || !hasProductCondition && (orderValueMin === null || orderValueMin === undefined || price >= orderValueMin);
    });
};
const isBenefitEmpty = (benefit)=>{
    return (!benefit.gifts || !benefit.gifts.length) && (!benefit.money || !benefit.money.length) && (!benefit.items || !benefit.items.length) && !benefit.voucher && !benefit.discount;
};
const getShowedPromotionsV2 = (promotions, price)=>{
    return promotions.filter((param)=>{
        let { condition , isDefault , benefit  } = param;
        if (!condition) return false;
        // Check valid promotion according to task https://jira.teko.vn/browse/UX4BUYER-7825
        if (!isDefault && !condition.coupon && isBenefitEmpty(benefit)) return false;
        const { hasProductCondition , orderValueMin  } = condition;
        return hasProductCondition || !hasProductCondition && (orderValueMin === null || orderValueMin === undefined || price >= orderValueMin);
    });
};
const useDetailPromotion = (product, price)=>{
    const { 0: allPromotions , 1: setAllPromotions  } = (0,react.useState)([]);
    const { 0: validPromotions , 1: setValidPromotions  } = (0,react.useState)([]);
    const { 0: promotions , 1: setPromotions  } = (0,react.useState)([]);
    const { user , loading  } = (0,context_es/* useAuth */.aC)();
    const { currentLanguage , terminalId , terminal , useTerminalId , displayPublicCouponInRelatedPromotions ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    (0,react.useEffect)(()=>{
        let isSubscribed = true;
        if (product && !loading) {
            const { sku  } = product;
            if (!sku) {
                index_es/* logger.error */.k.error("Exception: Calling PPM API get promotions with no product SKU, product info: ".concat(JSON.stringify(product || {})));
                return;
            }
            const getPromotionPromise = user ? ppmService.getPrivatePromotion : ppmService.getRelatedPromotion;
            getPromotionPromise(_objectSpreadProps(_objectSpread({
                type: displayPublicCouponInRelatedPromotions ? "coupon,order,qr,gift-code" : "coupon,order,qr",
                sku: sku
            }, flags.epic_ecom_284 || useTerminalId ? {
                terminalId
            } : {
                terminal
            }), {
                language: currentLanguage
            })).then((promotions)=>{
                if (!isSubscribed) return;
                const validPromotions = filterValidPromotions(promotions, product);
                const formattedPromotions = [];
                const formattedPromotionsV2 = [];
                for(const index in validPromotions){
                    //Epic: https://jira.teko.vn/browse/OMNI-552
                    if (validPromotions[index].type === "qr") {
                        formattedPromotions.push(_objectSpread({}, validPromotions[index]));
                        formattedPromotionsV2.push(_objectSpread({}, validPromotions[index]));
                    } else {
                        var ref;
                        formattedPromotions.push(...transformPromotion(validPromotions[index], sku));
                        if (!validPromotions[index].isDefault && !((ref = validPromotions[index].condition) === null || ref === void 0 ? void 0 : ref.coupon) && isBenefitEmpty(validPromotions[index].benefit)) {
                            continue;
                        }
                        formattedPromotionsV2.push(...transformPromotionV2(validPromotions[index], sku));
                    }
                }
                setAllPromotions(formattedPromotions);
                setValidPromotions(formattedPromotionsV2);
            });
        }
        return ()=>{
            isSubscribed = false;
        };
    }, [
        user,
        loading
    ]);
    (0,react.useEffect)(()=>{
        if (price && allPromotions.length) {
            setPromotions(getShowedPromotions(allPromotions, price));
            setValidPromotions(getShowedPromotionsV2(validPromotions, price));
        }
    }, [
        price,
        JSON.stringify(allPromotions)
    ]);
    return {
        promotions,
        validPromotions
    };
};
const useGetProductsCombos = function() {
    let skus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var ref;
    const { currentLanguage , terminalId , epicOmni1286  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { data , error  } = (0,index_esm/* default */.ZP)(epicOmni1286 && !!skus.length ? [
        "combos",
        skus.join()
    ] : null, async (_)=>{
        return await ppmService.getProductsCombos({
            skus,
            terminalId,
            language: currentLanguage
        });
    }, {
        revalidateOnFocus: false
    });
    return {
        result: {
            products: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.products) || []
        },
        isLoading: !error && !data,
        isError: error
    };
};


/***/ }),

/***/ 278585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ProductComboScreen; }
/* harmony export */ });
var ProductComboScreen;
(function(ProductComboScreen) {
    ProductComboScreen["cart"] = "cart";
    ProductComboScreen["product_detail"] = "product-detail";
})(ProductComboScreen || (ProductComboScreen = {}));


/***/ })

}]);